import React from "react";
import { useSettings } from "../../context/SettingsContext";
import { whatsappLink } from "../../lib/format";
import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  const { settings } = useSettings();
  const number = settings?.whatsapp_number || "+225 01 02 84 94 17";
  return (
    <a
      href={whatsappLink(number, "Bonjour Le Dressing de Yoyo, j'aimerais avoir des informations.")}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-button"
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3 text-sm font-medium text-white shadow-2xl transition-transform hover:scale-110 active:scale-95"
    >
      <MessageCircle className="h-5 w-5" />
      <span className="hidden sm:inline">Discuter</span>
    </a>
  );
}
